import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { SarFaslAmozeshiService } from 'src/app/Service/SarFaslAmozeshi/SarFaslAmozeshi.service';

@Component({
  selector: 'app-SarFaslAmozeshiList',
  templateUrl: './SarFaslAmozeshiList.component.html',
  styleUrls: ['./SarFaslAmozeshiList.component.scss']
})
export class SarFaslAmozeshiListComponent implements OnInit {

  Token:String=""
  Filter_title:string=""
  page:number=0;
  Procssing:boolean=false

  modalRef_Delete: any;

  constructor(
    private SarFaslAmozeshi_Service:SarFaslAmozeshiService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private modalService: BsModalService
  ) { }


  DataList_SarFaslAmozeshi:Array<General_Interface>=[]
  Data_Seleted_Delete:General_Interface=Empty_General_Interface()

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.Nav_Service.CheckValidPage(this.Token,25).subscribe(
      data=>{
        this.ReadData_SarFaslAmozeshi()
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )

    
  }

  ReadData_SarFaslAmozeshi(){
    this.Procssing=true
    this.SarFaslAmozeshi_Service.GetRecord(this.Token).subscribe(
      data=>{
        this.DataList_SarFaslAmozeshi=data
        this.Procssing=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  Change_Filter_title(){
    this.page=0
  }

  Delete(item:General_Interface){
    item.DeletingProccess=true
    this.modalRef_Delete.hide()
    this.SarFaslAmozeshi_Service.DeleteSarFaslAmozeshi(item.id,this.Token).subscribe(
      data=>{
        if(item.del==false)
          this.Alertify_Service.SuccessMessage("Deactivated successfully.")
        else
          this.Alertify_Service.SuccessMessage("Activated successfully.")
        this.ReadData_SarFaslAmozeshi()
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  openModal(template: TemplateRef<any>,Record) {
    this.Data_Seleted_Delete=Record
    this.modalRef_Delete = this.modalService.show(template);
  }

}
